<template>
    <div>
        <div class="card mb-3" style="min-height: 56vh; overflow: auto;">
            <div class="card-body">
                <div class="row">
                    <h3 class="col card-title"> Wavelet Marketplace</h3>
                    <div class="col pr-0">
                        <div class="float-right "><a-input-search placeholder="Search" style="width: 100%" @search="onSearch" /></div> 
                    </div>
                </div>
                <div class="row">
                    <div v-if='liveWavelets.length > 0'>            
                        <a-card  size="small" style="width:100%;">
                            <a-card-grid @click='showDetailDrawer(w)' v-for='w in liveWavelets' :key="w.id" class="col-4 p-3" style="cursor: pointer; max-height: 80vh; overflow: hidden;">
                                <table class="table table-borderless" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
                                    <tbody>
                                        <tr>
                                            <td class="h3 p-0 prevent-overflow"> {{w.name}}<br> <div class="text-muted p-0" style="font-weight: normal;">{{w.developer_account_name}}</div></td>
                                            <td class="p-0">
                                                <a-avatar class='float-right' style="color: #2BAE66FF; backgroundColor: #A8D5BAFF">
                                                    {{w.name.charAt(0)}} 
                                                </a-avatar>
                                            </td>
                                        </tr>
                                    
                                    </tbody>
                                </table>
                                <table class="table table-borderless" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
                                    <tbody>
                                        <tr>
                                            <td class="p-0 pt-2">
                                                <a-rate style="fontSize: 2vh" :value="Math.round(Number(w.average_rating))" disabled allow-half>
                                                    <a-icon slot="character" type="star"/>
                                                </a-rate>
                                            </td>
                                            <td v-if="w.web_wavelet != null" class="p-0 pt-2 lead text-right prevent-overflow" style="color: #33691E;"><strong v-if='w.web_wavelet.price > 0'>Web: ₱{{w.web_wavelet.price}}</strong><strong v-else>Web: Free</strong></td>
                                            <td v-if="w.pos_wavelet != null" class="p-0 pt-2 lead text-right prevent-overflow" style="color: #33691E;"><strong v-if='w.pos_wavelet.price > 0'>POS: ₱{{w.pos_wavelet.price}}</strong><strong v-else>POS: Free</strong></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </a-card-grid>
                        </a-card>
                    </div>
                    <div v-else class="row mx-auto">
                        <a-empty a-empty class='mt-5' :image-style="{height: '50px',}" >
                            <span slot="description">No Results </span>
                        </a-empty>
                    </div>
                </div>
                <div class="row pt-3 align-text-bottom">
                    <div class="col">
                        <a-pagination class="float-right" :current="current" :pageSize="perPage" :total="total" @change="onChange" />
                    </div>
                </div>
            </div>
        </div>

        <a-drawer
                :key="componentKey"
                :width="640"
                placement="right"
                :visible="detailDrawerVisible"
                @close="onDetailDrawerClose"
            >
                <wavelet-purchase-form @closeDrawer="closeDrawer" :key="componentKey" :closeDrawer='closeDrawer'></wavelet-purchase-form>
        </a-drawer>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import WaveletPurchaseForm from './WaveletPurchaseForm.vue'
    import axios from "axios";
    import { mapState, mapActions } from 'vuex'
    var component_x;

    export default {
        components:{
            WaveletPurchaseForm
        },
        mounted: async function(){  
            component_x = this;
            await this.retrievePagination();
            this.retrieveLiveWavelets(this.current);
        },
        filters: {
            truncate: function (text, length, suffix) {
                if (text.length > length){
                    return text.substring(0, length) + suffix;
                }else {
                    return text
                }
                
            },
        },
        computed: {
            ...mapState(['endPoint']),
        },
        data() {
            return {
                fetching: false, 
                current: 0,
                total: 0,
                perPage: 9,
                lastPage: 0,
                liveWavelets: [],
                currentWavelet: {},
                detailDrawerVisible: false,
                optionsDrawerVisible: false,
                componentKey: 0,
            }
        },
        methods: {
            ...mapActions(['updateSelectedWavelet']),
            closeDrawer(){
                this.onDetailDrawerClose();
            },
            async retrievePagination(mode, value){
                switch(mode) {
                    case 'name':
                        var pagination = await HTTPRequest.getRequest(component_x.endPoint + 'wavelets?status=L&mobile=0&per_page='+this.perPage+'&name='+value, null)
                        break;
                    default:
                        var pagination = await HTTPRequest.getRequest(component_x.endPoint + 'wavelets?status=L&mobile=0&per_page='+this.perPage, null)
                }
                this.current = pagination.current_page
                this.total = pagination.total
                this.lastPage = pagination.last_page
            },
            async retrieveLiveWavelets(current, mode, value){
                var liveWavelets = []
                switch(mode) {
                    case 'name':
                         liveWavelets = await HTTPRequest.getRequest(component_x.endPoint + 'wavelets?status=L&mobile=0&per_page='+this.perPage+'&page='+current+'&name='+value, null)
                        break;
                    default:
                         liveWavelets = await HTTPRequest.getRequest(component_x.endPoint + 'wavelets?status=L&mobile=0&per_page='+this.perPage+'&page='+current, null)
                }
                this.liveWavelets = liveWavelets.data
            },
            onChange(current) {
                this.current = current;
                this.retrieveLiveWavelets(this.current);
            },
            async showDetailDrawer(value) {
                this.updateSelectedWavelet(value)
                this.detailDrawerVisible = true;
                this.componentKey++
            },
            onDetailDrawerClose() {
                this.detailDrawerVisible = false;
                this.optionsDrawerVisible = false;
            },
            async onSearch(value){
                await this.retrievePagination('name', value);
                this.retrieveLiveWavelets(this.current, 'name', value);
            },
        }
    }
</script>

<style scoped>

.prevent-overflow {    
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

</style>


